export default function mapAnswersToQuestions(questions, answers) {
  return questions.map((q) => {
    const answerQuestion = answers.find((a) => a.question_id === q.id);
    return {
      ...q,
      ...answerQuestion
    };
  });
}
